import React, { useState } from 'react';
import '../App.css';
import axios from 'axios';
import {
    SERVER_URI,
} from "../utility/config";

function WhitelistedNumberCreatedMessage(props) {
    window.setTimeout(function () {
        props.handleClose();
    }, 1700);
    return (
        <div >
            <h2 className="message_title">Uusi numero lisätty luotettuihin</h2>
        </div>
    );
}

function AddWhitelist(props) {
    const [show, setShow] = useState(false);
    const [userData, setUserData] = useState({
        adminEmail: '',
        phoneNumber: '',
    })
    const [doesExist, setDoesExist] = useState(false);
    let storage = window.localStorage;
    let userToken = storage.getItem("admin_token")

    const doesWhitelistedNumberExist = async (e) => {
        try {
            let phoneNumber = e.target.value
            let doesWhitelistedNumberExist = ''
            doesWhitelistedNumberExist = await axios.get(`${SERVER_URI}/is_whitelisted/${phoneNumber}`, { headers: { "Authorization": `Token ${userToken}` } })
            let exists = doesWhitelistedNumberExist.data.isWhitelisted
            if (exists === false) {
                setUserData({ ...userData, phoneNumber: phoneNumber })
                setDoesExist(false)
            } else {
                alert("Numero on jo luotetuissa")
                setDoesExist(true)
            }
        } catch (e) {
            console.log("Error in whitelist", e)
        }

    }

    /* const onChange = (e) => {
        setUserData({ ...userData, [e.target.name]: e.target.value })
    } */

    //Submit
    const doSubmit = async (e) => {
        e.preventDefault()
        const dataToServer = {
            ...userData,
            phoneNumber: String(userData.phoneNumber),
        }
        const dataToReducer = {
            ...userData,
            phoneNumber: String(userData.phoneNumber),
        }
        if(doesExist === false) {
            try {
                let result = await axios.post(`${SERVER_URI}/add_to_whitelist/`, dataToServer, { headers: { "Authorization": `Token ${userToken}` } })
                props.dispatch({ type: "ADD_TO_WHITELIST", data: { newWhitelistedNumber: dataToReducer, id: result.data.id } })
                setShow(!show);
            } catch (e) {
                console.log("Error in adding to whitelist", e)
            }
        }else {
            alert("Puhelinnumero ei ole kelvollinen.")
        }
    }

    return (
        <div className="popUp_card">
            <div className="popup-box">
                <div className="box">
                    <span className="close-icon" onClick={props.handleClose}>x</span>
                    {!show && (
                        <div>
                            <h2 className="popUp_title">Lisää numero luotettuihin</h2>
                            <form className="add_driver_form" onSubmit={e => doSubmit(e)}>
                                <label className="label_add" htmlFor="phoneNumber">Puhelinnumero:</label>
                                <input type="tel" id="phoneNumber" name="phoneNumber" placeholder="Puhelinnumero" onChange={doesWhitelistedNumberExist} required></input><span className="validity"></span><br className="desktop-break" />
                                <input type="submit" id="gradient_Button" value="Lisää tiedot" />
                            </form></div>
                    )}
                    {show && <WhitelistedNumberCreatedMessage handleClose={props.handleClose} />}
                </div>
            </div>
        </div>

    );
}

export default AddWhitelist